define('home/collections/SettingsSocialAccountCollection',[
    'backbone',
    'underscore',

    'home/models/SettingsSocialAccount',
], function (
    Backbone,
    _,

    SettingsSocialAccount
) {
    'use strict';

    var SettingsSocialAccountCollection = Backbone.Collection.extend({
        model: SettingsSocialAccount,

        toJSON: function () {
            return _.reduce(this.models, function (data, model) {
                data[model.id] = model.toJSON();
                return data;
            }, {});
        },
    });

    return SettingsSocialAccountCollection;
});


